export default __webpack_public_path__ + "static/orange-whole-676b2746e0d1d8a49142a412f19e5677.svg";